import { render, staticRenderFns } from "./Balli.vue?vue&type=template&id=407455c3&"
import script from "./Balli.vue?vue&type=script&lang=ts&"
export * from "./Balli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports